export default "__VITE_ASSET__CEPPTNs5__"